<script setup lang="ts">
interface Props {
  progress?: number; // 0-100
  isUploading?: boolean;
}

withDefaults(defineProps<Props>(), {
  progress: 0,
  isUploading: false
});
</script>

<template>
  <div class="progress-bar">
    <div
      class="progress-bar__line"
      :class="{'progress-bar__line--complete': !isUploading && progress === 100}"
      :style="{ width: `${progress}%` }"
    />
  </div>
</template>

<style scoped lang="scss">
.progress-bar {
  position: relative;
  width: 100%;
  height: 8px;
  border-radius: 8px;
  background-color: var(--background-bg-main);

  &__line {
    position: absolute;
    height: 8px;
    border-radius: 8px;
    top: 0;
    left: 0;
    min-width: 0;
    max-width: 100%;
    background-color: var(--blue-blue80);
    transition: width 0.3s ease;

    &--complete {
     background-color: var(--green-green60);
    }
  }
}
</style>